/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Scrubber } from "./modelScrubber";

class ControllerScrubber extends ControllerModel {
    constructor() {
        super("ControllerScrubber");

        this.setNewNode = (callback) => {
            let scrubber = new Scrubber();
            scrubber.decorate(callback);

            this.addNode(scrubber);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let scrubber = new Scrubber();
            scrubber.copyFrom(node);
            scrubber.decorate(callback);
            this.addNode(scrubber)
        }

        this.getProperties = async (node) => {
            let n = new Scrubber();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Scrubber();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerScrubber };